/* eslint-disable @typescript-eslint/no-empty-function */
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { Typography } from '@mui/material';
import { MachineSummary } from './MachineGroupMachines';

type Params = {
  machineSummary: MachineSummary | undefined;
};

function SyncProgress({ machineSummary }: Params) {
  const finished = machineSummary?.taskSummaryAggregate.finished ?? 0;
  const failed = machineSummary?.taskSummaryAggregate.failed ?? 0;
  const cancelled = machineSummary?.taskSummaryAggregate.cancelled ?? 0;
  const completed = finished + failed + cancelled;
  const total = machineSummary?.taskSummaryAggregate.total ?? 0;
  const progress = 100 * (completed / total);

  return completed === total &&
    (machineSummary?.taskSummaryAggregate.aggregatedStatus === 'Finished' ||
      machineSummary?.taskSummaryAggregate.aggregatedStatus === 'Failed' ||
      machineSummary?.taskSummaryAggregate.aggregatedStatus === 'Cancelled') ? (
    <>
      {total === 0 ? (
        <text
          style={{
            visibility: total === 0 ? 'visible' : 'hidden',
          }}
        >
          Not synced yet
        </text>
      ) : (
        ''
      )}
      {finished !== 0 ? (
        <text
          style={{
            color: 'green',
            visibility: finished !== 0 ? 'visible' : 'hidden',
            marginRight: '1em',
          }}
        >
          Success: {finished}
        </text>
      ) : (
        ''
      )}
      {failed !== 0 ? (
        <text
          style={{
            color: 'red',
            visibility: failed !== 0 ? 'visible' : 'hidden',
            marginRight: '1em',
          }}
        >
          Failed: {failed}
        </text>
      ) : (
        ''
      )}
      {cancelled !== 0 ? (
        <text
          style={{
            color: 'orange',
            visibility: cancelled !== 0 ? 'visible' : 'hidden',
          }}
        >
          Cancelled: {cancelled}
        </text>
      ) : (
        ''
      )}
    </>
  ) : (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Box sx={{ flex: 1 }}>
        <LinearProgress
          variant="buffer"
          sx={{ height: '0.5em' }}
          value={progress}
          valueBuffer={0}
        />
      </Box>
      <Box sx={{ width: 'auto', marginLeft: 1 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${completed}/${total}`}
        </Typography>
      </Box>
    </Box>
  );
}

export default SyncProgress;
